import React, { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import blogsData from "./BlogData";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import "../styles/slider.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Home = () => {
  const [statusMsg, setStatusMsg] = useState("");
  const [isSuccess, setIsSuccess] = useState(null); 
  const [loading, setLoading] = useState(false);
   const { ref, inView } = useInView({
    threshold: 0.001,
    triggerOnce: true,
  });
  
const { ref: topRef, inView: topInView } = useInView({
  triggerOnce: true,
  threshold: 0.3,
});

const { ref: bottomRef, inView: bottomInView } = useInView({
  triggerOnce: true,
  threshold: 0.3,
});
   useEffect(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, []);

   useEffect(() => {
    const items = document.querySelectorAll(".faq-item h3, .faq-item .faq-toggle");
    items.forEach((faqItem) => {
      faqItem.addEventListener("click", () => {
        faqItem.parentNode.classList.toggle("faq-active");
      });
    });

    return () => {
      // cleanup event listeners on unmount
      items.forEach((faqItem) => {
        faqItem.replaceWith(faqItem.cloneNode(true));
      });
    };
  }, []);

   const activateTab = (tabId) => {
      // Remove active/show from all tabs
      const allTabs = document.querySelectorAll(".tab-pane");
      allTabs.forEach(tab => {
        tab.classList.remove("active", "show");
      });
    
      // Remove active class from all nav links
      const allNavLinks = document.querySelectorAll(".nav-link");
      allNavLinks.forEach(link => link.classList.remove("active", "show"));
    
      // Add active/show to clicked tab
      const targetTab = document.getElementById(tabId);
      if (targetTab) targetTab.classList.add("active", "show");
    
      // Add active class to corresponding nav link
      const navLink = document.querySelector(`a[data-bs-target="#${tabId}"]`);
      if (navLink) navLink.classList.add("active", "show");
    
      // Scroll to services section smoothly
      document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
       };

     const techs = [
    { name: "Angular", icon: "bi-code-slash", color: "pink" },
    { name: "React", icon: "bi-lightning-charge", color: "blue" },
    { name: "AWS", icon: "bi-cloud", color: "green" },
    { name: "Docker", icon: "bi-box-seam", color: "red" },
    { name: "Azure", icon: "bi-cloud-arrow-up", color: "purple" },
    { name: "Vue", icon: "bi-diagram-3", color: "teal" },
    { name: "Python", icon: "bi-cpu", color: "yellow" },
    { name: "JavaScript", icon: "bi-braces", color: "pink" },
    { name: "Semantic", icon: "bi-layout-text-window", color: "cyan" },
    { name: "Go Lang", icon: "bi-gear", color: "orange" },
    { name: ".NET", icon: "bi-windows", color: "blue" },
    { name: "PHP", icon: "bi-file-code", color: "green" },
    { name: "NodeJs", icon: "bi-node-plus", color: "red" },
    { name: "CSS 3", icon: "bi-palette", color: "purple" },
    { name: "Bootstrap", icon: "bi-layers", color: "teal" },
    { name: "Big Data", icon: "bi-bar-chart", color: "yellow" },
    { name: "Salesforce", icon: "bi-lightbulb", color: "pink" },
    { name: "DevOps", icon: "bi-gear-wide-connected", color: "cyan" },
    { name: "Workday", icon: "bi-briefcase", color: "orange" },
     { name: "AI & Ml ", icon: "bi-briefcase", color: "green" },
     ];

     const techLogos = [
  { logo: process.env.PUBLIC_URL + "/assets/logo/1.svg" },
  { logo: process.env.PUBLIC_URL + "/assets/logo/2.svg" },
  { logo: process.env.PUBLIC_URL + "/assets/logo/3.svg" },
  { logo: process.env.PUBLIC_URL + "/assets/logo/4.svg" },
  { logo: process.env.PUBLIC_URL + "/assets/logo/5.svg" },
  { logo: process.env.PUBLIC_URL + "/assets/logo/6.svg" },
  { logo: process.env.PUBLIC_URL + "/assets/logo/7.svg" },
  { logo: process.env.PUBLIC_URL + "/assets/logo/8.svg" },
  // add more logos here
];
 useEffect(() => {
  AOS.init({
    duration: 1000,
    once: true
  });
}, []);
  
   const [isReading, setIsReading] = useState(false);
     const [assistantActive, setAssistantActive] = useState(false);
     const [hasGreeted, setHasGreeted] = useState(false);
     const [voicesReady, setVoicesReady] = useState(false);
   
     const speechRecRef = useRef(null);
     const highlightTimerRef = useRef(null);
     const fallbackTimerRef = useRef(null);
     const utteranceRef = useRef(null);
     const selectedVoiceRef = useRef(null);
   
     const femaleVoicePriority = [
       // common voice names on Chrome/Windows/Mac OS variants
       "Google UK English Female",
       "Google US English",
       "Samantha", // macOS
       "Alex", // macOS (male but good TTS); fallback
       "Microsoft Zira Desktop",
       "Microsoft Hazel Desktop",
       "Microsoft Heera Desktop",
       "Karen",
     ];
    
     const handleSubmit = async (e) => {
    e.preventDefault(); 
    setLoading(true);

    const formData = new FormData(e.target);

    try {
  const response = await fetch("https://bojotech.com/sendMail.php", {
    method: "POST",
    body: formData,
  });

  const resultText = (await response.text()).trim();
  console.log("API Response:", resultText);

  if (response.status === 200 && resultText.toLowerCase().includes("success")) {
  setIsSuccess(true);
  setStatusMsg("Your message has been sent. Thank you!");
  e.target.reset();
} else {
  setIsSuccess(false);

  setStatusMsg(`Failed to send message: ${resultText}`);
}


} catch (err) {
  console.log(err);
  setIsSuccess(false);
  setStatusMsg("Failed to send message (Network error).");
} finally {
  setLoading(false);
}


    setTimeout(() => {
      setStatusMsg("");
      setIsSuccess(null);
    }, 5000);
     };

   
     useEffect(() => {
       // Load voices and choose a preferred voice when available
       const loadVoices = () => {
         const voices = window.speechSynthesis.getVoices() || [];
         if (voices.length > 0) {
           selectedVoiceRef.current = choosePreferredVoice(voices);
           setVoicesReady(true);
         }
       };
   
       loadVoices();
       // Some browsers load voices asynchronously
       window.speechSynthesis.onvoiceschanged = () => {
         loadVoices();
       };
   
       // cleanup
       return () => {
         window.speechSynthesis.onvoiceschanged = null;
         stopReadingImmediate();
         if (speechRecRef.current) {
           try {
             speechRecRef.current.stop();
           } catch (e) {}
         }
       };
       // eslint-disable-next-line react-hooks/exhaustive-deps
     }, []);
   
     const choosePreferredVoice = (voices) => {
       // try by priority names
       for (const name of femaleVoicePriority) {
         const found = voices.find((v) => v.name && v.name.includes(name));
         if (found) return found;
       }
      
  
       // otherwise prefer voices where lang includes 'en' and name includes female-like keywords
       const femaleLike = voices.find(
         (v) =>
           v.lang && v.lang.toLowerCase().startsWith("en") &&
           (v.name && /female|woman|zira|samantha|karen|hazel|alloy|google/i.test(v.name))
       );
       if (femaleLike) return femaleLike;
   
       // final fallback: any 'en' voice
       const en = voices.find((v) => v.lang && v.lang.toLowerCase().startsWith("en"));
       if (en) return en;
   
       // else the first available voice
       return voices[0] || null;
     };
   
     const readElementText = (elementOrSelector) => {
       const element =
         typeof elementOrSelector === "string"
           ? document.querySelector(elementOrSelector)
           : elementOrSelector;
       if (!element) {
         console.warn("Element to read not found:", elementOrSelector);
         return;
       }
   
       stopReadingImmediate(); // ensure previous speech stopped
   
       const plainText = getPlainText(element);
       if (!plainText.trim()) return;
   
       const u = new window.SpeechSynthesisUtterance(plainText);
       u.rate = 0.9; // slower reading
       u.pitch = 1.0;
       u.lang = "en-US";
       if (selectedVoiceRef.current) u.voice = selectedVoiceRef.current;
   
       utteranceRef.current = u;
       setIsReading(true);
   
       // bind events
       let boundarySupported = false;
       u.onboundary = (ev) => {
         boundarySupported = true;
         // event.charIndex gives index into full text
         if (ev.charIndex !== undefined) {
           applyHighlightByCharIndex(element, plainText, ev.charIndex);
         }
       };
   
       u.onend = () => {
         clearAllHighlighting(element, plainText);
         setIsReading(false);
         clearTimers();
       };
   
       // fallback if onboundary isn't supported in this browser: estimate word timings
       // We'll compute rough durations and step through words
       // Start speaking, then if onboundary didn't fire after a short delay, start fallback timer.
       window.speechSynthesis.speak(u);
   
       // start fallback check after 250ms
       fallbackTimerRef.current = setTimeout(() => {
         if (!boundarySupported) {
           // start estimated highlighting
           startFallbackHighlight(element, plainText, u.rate);
         }
       }, 250);
     };
   
     // Get plain text of element (no tags). Keep small whitespace formatting.
     const getPlainText = (el) => {
       // prefer textContent but keep spacing
       return el.textContent || el.innerText || "";
     };
   
     const applyHighlightByCharIndex = (element, fullText, charIndex) => {
       // We find the current word from charIndex and wrap that word in span
       // Preserve original whitespace by reconstructing innerHTML from slices.
       const before = fullText.slice(0, charIndex);
       const after = fullText.slice(charIndex);
       // extract current word
       const wordsBefore = before.split(/\s+/);
       let currentWord = wordsBefore[wordsBefore.length - 1] || "";
       // fallback if empty
       if (!currentWord) {
         // try to skip any non-word
         const trimmed = fullText.slice(charIndex).trim();
         currentWord = trimmed.split(/\s+/)[0] || "";
       }
   
       const start = Math.max(0, before.lastIndexOf(currentWord));
       const end = start + currentWord.length;
   
       // escape HTML (we'll set innerHTML to composed string)
       const esc = (s) =>
         s
           .replace(/&/g, "&amp;")
           .replace(/</g, "&lt;")
           .replace(/>/g, "&gt;")
           .replace(/"/g, "&quot;");
   
       const part1 = esc(fullText.slice(0, start));
       const partHighlight = esc(fullText.slice(start, end));
       const part2 = esc(fullText.slice(end));
   
       element.innerHTML =
         part1 +
         `<span class="tts-highlight" style="background:lightblue;border-radius:3px;">` +
         partHighlight +
         `</span>` +
         part2;
     };
   
     const clearAllHighlighting = (element, fullText) => {
       // put plain text back
       element.innerText = fullText;
       // clear timers
       clearTimers();
     };
   
     const clearTimers = () => {
       if (highlightTimerRef.current) {
         clearInterval(highlightTimerRef.current);
         highlightTimerRef.current = null;
       }
       if (fallbackTimerRef.current) {
         clearTimeout(fallbackTimerRef.current);
         fallbackTimerRef.current = null;
       }
     };
   
     const startFallbackHighlight = (element, fullText, rate = 1.0) => {
       // Estimate reading duration: average characters spoken per second at rate=1 ~ 13
       // (This is heuristic; adjust if needed)
       const avgCharsPerSec = 13 * rate;
       const estimatedTotalSec = Math.max(1, fullText.length / avgCharsPerSec);
       const words = fullText.split(/\s+/).filter(Boolean);
       if (words.length === 0) return;
   
       // compute duration proportionally per word by its char length
       const totalChars = words.reduce((s, w) => s + w.length, 0);
       const wordDurations = words.map((w) => (w.length / totalChars) * estimatedTotalSec);
   
       // iterate words
       let idx = 0;
       const paintWord = () => {
         if (!words[idx]) {
           // finish
           element.innerText = fullText;
           setIsReading(false);
           clearTimers();
           return;
         }
         // Rebuild string highlighting words[idx]
         const prefix = words.slice(0, idx).join(" ");
         const current = words[idx];
         const suffix = words.slice(idx + 1).join(" ");
   
         // careful: reconstruct with same spacing - using split/join loses multiple spaces/newlines.
         // For fallback we will approximate using single spaces.
         element.innerHTML =
           (prefix ? prefix + " " : "") +
           `<span class="tts-highlight" style="background:lightblue;border-radius:3px;">${current}</span>` +
           (suffix ? " " + suffix : "");
   
         const durMs = Math.max(80, Math.round(wordDurations[idx] * 1000));
         idx++;
         highlightTimerRef.current = setTimeout(paintWord, durMs);
       };
   
       paintWord();
     };
   
     const stopReadingImmediate = () => {
       // stop speech and clear highlight/timers
       window.speechSynthesis.cancel();
       utteranceRef.current = null;
       clearTimers();
       // restore any element innerText to original for any open sections we may have changed
       // (We will try to find any highlighted elements and remove highlight)
       const highlighted = document.querySelectorAll(".tts-highlight");
       highlighted.forEach((span) => {
         const parent = span.parentNode;
         if (parent) {
           // replace parent HTML with its textContent (best-effort)
           const parentFull = parent.innerText || parent.textContent || "";
           parent.innerText = parentFull;
         }
       });
       setIsReading(false);
     };
   
     const handleReadButton = () => {
       const aboutEl = document.querySelector("#about .about-description");
       if (!isReading) {
         readElementText(aboutEl);
       } else {
         stopReadingImmediate();
       }
     };
   
     // Stop assistant & reading completely (optional UI)
     const stopAssistantAndReading = () => {
       stopReadingImmediate();
       if (speechRecRef.current) {
         try {
           speechRecRef.current.stop();
         } catch (e) {}
         speechRecRef.current = null;
       }
       setAssistantActive(false);
       setHasGreeted(false);
     };
   
      const scrollRef = useRef(null);

  const handleScrollRight = () => {
  if (scrollRef.current) {
    const card = scrollRef.current.querySelector(".card");
    const cardWidth = card.offsetWidth + 24; // card + gap
    scrollRef.current.scrollBy({
      left: cardWidth * 3,
      behavior: "smooth"
    });
  }
};

const handleScrollLeft = () => {
  if (scrollRef.current) {
    const card = scrollRef.current.querySelector(".card");
    const cardWidth = card.offsetWidth + 24;
    scrollRef.current.scrollBy({
      left: -(cardWidth * 3),
      behavior: "smooth"
    });
  }
};
  
  
  return (
   <div >
   
    {/* Hero Section */}
    <section id="hero" className="hero section">
  <div className="container" data-aos="fade-up" data-aos-delay={100}>
    <div className="row align-items-center">
      {/* Left Column: Hero Content */}
      <div className="col-lg-6">
        <div className="hero-content" data-aos="fade-up" data-aos-delay={200}>
          <div className="company-badge mb-4">
            <i className="bi bi-gear-fill me-2" />
            Driving Your Success
          </div>
          <h1 className="mb-4">
            Empowering <br />
            Talent & Businesses <br />
            <span className="accent-text">For Growth & Innovation</span>
          </h1>
          <p className="mb-4 mb-md-5">
            We empower organizations to scale and innovate through custom software development, advanced AI solutions, 
            and strategically tailored staffing services. Our integrated approach combines technical excellence with business 
            insight, enabling our clients to optimize performance, accelerate digital transformation, and achieve sustainable 
            growth. We are committed to delivering measurable impact, long-term value, and trusted partnerships.
          </p>
          <div className="hero-buttons">
            <Link to="/about" className="btn btn-primary me-0 me-sm-2 mx-1">Explore More</Link>
          </div>
        </div>
      </div>

      {/* Right Column: Hero Image */}
      <div className="col-lg-6">
        <div className="hero-image" data-aos="zoom-out" data-aos-delay={300}>
          <img src="assets/Welcome_Image.png" alt="Hero Illustration" className="img-fluid" />
          <div className="customers-badge">
            <div className="customer-avatars">
              <img src="assets/img/avatar-1.webp" alt="Customer 1" className="avatar" />
              <img src="assets/img/avatar-2.webp" alt="Customer 2" className="avatar" />
              <img src="assets/img/avatar-3.webp" alt="Customer 3" className="avatar" />
              <img src="assets/img/avatar-4.webp" alt="Customer 4" className="avatar" />
              <img src="assets/img/avatar-5.webp" alt="Customer 5" className="avatar" />
              <span className="avatar more">12+</span>
            </div>
            <p className="mb-0 mt-2">Trusted by 200+ professionals and businesses worldwide</p>
          </div>
        </div>
      </div>
    </div>

    {/* Stats Row */}
    <div className="text-center mt-5" data-aos="fade-up" data-aos-delay={600}>
      <h3 className="fw-bold">Award-Winning Agency</h3>
       <p className="mt-3 mb-0">
    We relentlessly pursue opportunities for others because when we all work
    together, anything is possible with a great environment.
       </p>
    </div>

     <div
  ref={ref}
  className="row stats-row gy-4 mt-5"
  data-aos="fade-up"
  data-aos-delay={500}
>

  <div className="col-lg-3 col-md-6">
    <div className="stat-item">
      <div className="stat-icon">
        <i className="bi bi-emoji-smile" />
      </div>
      <div className="stat-content">
        <h4>
          {inView && (
            <CountUp start={0} end={30} duration={5} redraw={true} />
          )}+
        </h4>
        <p>Happy Clients</p>
      </div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6">
    <div className="stat-item">
      <div className="stat-icon">
        <i className="bi bi-diagram-3" />
      </div>
      <div className="stat-content">
        <h4>
          {inView && (
            <CountUp start={0} end={50} duration={3} redraw={true} />
          )}+
        </h4>
        <p>Projects</p>
      </div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6">
    <div className="stat-item">
      <div className="stat-icon">
        <i className="bi bi-headset" />
      </div>
      <div className="stat-content">
        <h4>
          {inView && (
            <CountUp start={0} end={2000} duration={3} redraw={true} />
          )}+
        </h4>
        <p>Hours of Support</p>
      </div>
    </div>
  </div>

  <div className="col-lg-3 col-md-6">
    <div className="stat-item">
      <div className="stat-icon">
        <i className="bi bi-people" />
      </div>
      <div className="stat-content">
        <h4>
          {inView && (
            <CountUp start={0} end={80} duration={5} redraw={true} />
          )}+
        </h4>
        <p>Hard Workers</p>
      </div>
    </div>
  </div>
</div>



  </div>
</section>
    {/* /Hero Section */}
   
    {/* About Section */}
   <section id="about" className="about section py-5">
      <div className="container">
         <div className="container section-title text-center mb-2">
        <h2>WHO WE ARE</h2>
      </div>
        <div className="row gy-4 align-items-center justify-content-between">

          {/* Left Column */}
          <div className="col-xl-5">
             
            <p className="about-description">
             BOJO is a forward-thinking technology company focused on helping businesses turn their ideas into powerful
              digital solutions. We work closely with clients to design and develop custom software, intelligent automation
              systems, and scalable digital platforms that simplify complex processes and improve operational efficiency.

              Our team combines strong technical expertise with creative problem-solving to transform concepts into reliable,
              secure, and future-ready digital products. From startups with innovative ideas to established enterprises seeking
              modernization, we partner with organizations to build technology solutions tailored to their unique needs.

            </p>

            {/* Technologies */}
            <div className="row feature-list-wrapper mb-4">
              <div className="col-md-12">
                <h5 className="mb-3">Our Expertise:</h5>
                <ul className="feature-list d-flex flex-wrap gap-3">
                  <li><i className="bi bi-check-circle-fill" /> Custom IT Solutions</li>
                  <li><i className="bi bi-check-circle-fill" /> Scalable Architecture</li>
                  <li><i className="bi bi-check-circle-fill" /> Cloud Integration</li>
                  <li><i className="bi bi-check-circle-fill" /> AI Consulting</li>
                  <li><i className="bi bi-check-circle-fill" /> Agile & Efficient Processes</li>
                  <li><i className="bi bi-check-circle-fill" /> Enterprise-Grade Security</li>
                  <li><i className="bi bi-check-circle-fill" /> Continuous Innovation</li>

                 
                </ul>
              </div>
            </div>

       
            {/* 🔊 Button */}
            <button
                  className={`btn ${isReading ? "btn-danger" : "btn-primary"} mt-4`}
                  onClick={handleReadButton}
                >
                  {isReading ? "Stop Reading" : "Read Full Section"}
                </button>
          </div>

          {/* Right Column */}
          <div className="col-xl-6" data-aos="fade-up" data-aos-delay={300}>
            <div className="image-wrapper position-relative">
              <div className="images position-relative">
                <img
                  src="assets/Picture2(a).png"
                  alt="Business Meeting"
                  className="img-fluid main-image rounded-4"
                />
                <img
                  src="assets/Picture2(b).png"
                  alt="Team Discussion"
                  className="img-fluid small-image rounded-4"
                />
              </div>
              <div className="experience-badge floating">
                <h3>15+<span>Years</span></h3>
                <p>of experience delivering exceptional IT services</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
    {/* /About Section */}
  
      {/* services Section */}
  
 <section id="services" className="features-cards section py-5">
  <div className="container text-center">

      {/* Section Title */}
      <div className="container section-title text-center mb-5" data-aos="fade-up">
        <h2>Our Services</h2>
        <p>
          We provide a wide range of technology solutions designed to drive growth, efficiency, and security for your business.
        </p>
      </div>

      {/* Slider Controls */}
      <div className="slider-container position-relative">
      <button className="slider-btn left" onClick={handleScrollLeft}>
        &#10094;
        </button>
        <div className="slider" ref={scrollRef}>
          {/* --- CARD 1 --- */}
          <div className="card shadow-sm border-0 rounded-4">
            <img src="assets/Service_1.png" className="card-img-top" alt="Custom Software" />
            <div className="card-body">
              <h4>Custom Software Development</h4>
              <p className="card-text">
                Tailored business software built for scalability and reliability.
              </p>
              <Link to="/services?tab=1" className="btn btn-primary btn-sm rounded-pill mt-2">
                  Read More
              </Link>
            </div>
          </div>

           {/* --- CARD new --- */}
          <div className="card shadow-sm border-0 rounded-4">
            <img src="assets/Service_8.png" className="card-img-top" alt="Custom Software" />
            <div className="card-body">
              <h4>AI Consulting</h4>
              <p className="card-text">
                Transforming businesses using powerful artificial intelligence solutions.
              </p>
              <Link to="/services?tab=8" className="btn btn-primary btn-sm rounded-pill mt-2">
                  Read More
              </Link>
            </div>
          </div>

          {/* --- CARD 2 --- */}
          <div className="card shadow-sm border-0 rounded-4">
            <img src="assets/Service_3.png" className="card-img-top" alt="Cloud Solutions" />
            <div className="card-body">
              <h4>Cloud Solutions</h4>
              <p className="card-text">
                Harness the cloud to improve agility, reduce costs, and boost security.
              </p>
              <Link to="/services?tab=2" className="btn btn-primary btn-sm rounded-pill mt-2">
                  Read More
              </Link>
            </div>
          </div>

          {/* --- CARD 3 --- */}
          <div className="card shadow-sm border-0 rounded-4">
            <img src="assets/Service_4.png" className="card-img-top" alt="Mobile Apps" />
            <div className="card-body">
              <h4>Mobile App Development</h4>
              <p className="card-text">
                Engaging, high-performance apps for iOS and Android platforms.
              </p>
              <Link to="/services?tab=3" className="btn btn-primary btn-sm rounded-pill mt-2">
                  Read More
              </Link>
            </div>
          </div>

          {/* --- CARD 4 --- */}
          <div className="card shadow-sm border-0 rounded-4">
            <img src="assets/Service_5.png" className="card-img-top" alt="Cybersecurity" />
            <div className="card-body">
              <h4>Cybersecurity</h4>
              <p className="card-text">
                Protect your digital assets with robust monitoring and defense.
              </p>
              <Link to="/services?tab=4" className="btn btn-primary btn-sm rounded-pill mt-2">
                  Read More
              </Link>
            </div>
          </div>

          {/* --- CARD 5 --- */}
          <div className="card shadow-sm border-0 rounded-4">
            <img src="assets/Service_6.png" className="card-img-top" alt="Data Analytics" />
            <div className="card-body">
              <h4>Data Analytics</h4>
              <p className="card-text">
                Transform raw data into insights that drive business growth.
              </p>
              <Link to="/services?tab=5" className="btn btn-primary btn-sm rounded-pill mt-2">
                  Read More
              </Link>
            </div>
          </div>

          {/* --- CARD 6 --- */}
          <div className="card shadow-sm border-0 rounded-4">
            <img src="assets/Service_2.png" className="card-img-top" alt="Consultation" />
            <div className="card-body">
              <h4>Consultation</h4>
              <p className="card-text">
                Get expert advice to improve efficiency and technology ROI.
              </p>
              <Link to="/services?tab=6" className="btn btn-primary btn-sm rounded-pill mt-2">
                  Read More
              </Link>
            </div>
          </div>

          {/* --- CARD 7 --- */}
          <div className="card shadow-sm border-0 rounded-4">
            <img src="assets/Service_7.png" className="card-img-top" alt="Staff Augmentation" />
            <div className="card-body">
              <h4>Staff Augmentation</h4>
              <p className="card-text">
                Scale your workforce flexibly with top technical talent.
              </p>
              <Link to="/services?tab=7" className="btn btn-primary btn-sm rounded-pill mt-2">
                  Read More
              </Link>
            </div>
          </div>
        </div>
    
      <button className="slider-btn right" onClick={handleScrollRight}>
      &#10095;
      </button>
      </div>
      </div>
    </section>
  {/* /services Section */}

    {/* expertise Cards Section */}
  <section id="expertise" className="features-cards section py-5">
      <div className="container text-center">
        <div
          className="section-title"
          data-aos="fade-up"
          style={{ marginBottom: "30px" }}
        >
          <h2>Our Technical Expertise:</h2>
          <p>
            We leverage the latest and most powerful technologies to build
            scalable, secure, and high-performing solutions across platforms.
          </p>
        </div>

        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={20}
          slidesPerView={5}
          navigation
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          loop={true}
          breakpoints={{
            320: { slidesPerView: 2 },
            640: { slidesPerView: 3 },
            1024: { slidesPerView: 5 },
          }}
          className="tech-slider"
        >
          {techs.map((tech, index) => (
            <SwiperSlide key={index}>
              <div className={`feature-box card-${tech.color}`}>
                <i className={`bi ${tech.icon}`} />
                <h4>{tech.name}</h4>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
    
    <br></br>
    {/* /expertise Cards Section */}


    {/* Features  Section */}
    <section id="features" className="features-2 section">
  <div className="container" data-aos="fade-up" data-aos-delay={100}>
     <div
          className="section-title"
          data-aos="fade-up"
          style={{ marginBottom: "5px" }}
        >
          <h2>Our Values</h2>
          <p>
            We leverage the latest and most powerful technologies to build
            scalable, secure, and high-performing solutions across platforms.
          </p>
        </div>
    <div className="row align-items-center">
      {/* Left Side Features */}
      <div className="col-lg-4">
        <div className="feature-item text-end mb-5" data-aos="fade-right" data-aos-delay={200}>
          <div className="d-flex align-items-center justify-content-end gap-4">
            <div className="feature-content">
              <h3>Customer Focus</h3>
              <p>We place our clients at the core of every decision. By understanding their unique needs and aspirations, we deliver tailored solutions and foster long-term partnerships built on trust and excellence.</p>
            </div>
            <div className="feature-icon flex-shrink-0">
              <i className="bi bi-people" />
            </div>
          </div>
        </div>
        <div className="feature-item text-end mb-5" data-aos="fade-right" data-aos-delay={300}>
          <div className="d-flex align-items-center justify-content-end gap-4">
            <div className="feature-content">
              <h3>Integrity</h3>
              <p>We uphold the highest ethical standards, ensuring honesty, transparency, and respect in all interactions. Confidentiality and trust are the foundation of our relationships with clients and partners.</p>
            </div>
            <div className="feature-icon flex-shrink-0">
              <i className="bi bi-shield-check" />
            </div>
          </div>
        </div>
        <div className="feature-item text-end" data-aos="fade-right" data-aos-delay={400}>
          <div className="d-flex align-items-center justify-content-end gap-4">
            <div className="feature-content">
              <h3>Excellence</h3>
              <p>We are committed to excellence in every project. Our team consistently goes beyond expectations, delivering innovative, high-quality solutions that drive measurable results for our clients.</p>
            </div>
            <div className="feature-icon flex-shrink-0">
              <i className="bi bi-trophy" />
            </div>
          </div>
        </div>
      </div>

      {/* Center Mockup */}
      <div className="col-lg-4" data-aos="zoom-in" data-aos-delay={200}>
        <div className="phone-mockup text-center">
          <img src="assets/phone.png" alt="Phone Mockup" className="img-fluid" />
        </div>
      </div>

      {/* Right Side Features */}
      <div className="col-lg-4">
        <div className="feature-item mb-5" data-aos="fade-left" data-aos-delay={200}>
          <div className="d-flex align-items-center gap-4">
            <div className="feature-icon flex-shrink-0">
              <i className="bi bi-people-fill" />
            </div>
            <div className="feature-content">
              <h3>Collaboration</h3>
              <p>We believe success is best achieved together. By fostering teamwork and open communication, we create synergies that lead to stronger ideas and impactful outcomes for our clients.</p>
            </div>
          </div>
        </div>
        <div className="feature-item mb-5" data-aos="fade-left" data-aos-delay={300}>
          <div className="d-flex align-items-center gap-4">
            <div className="feature-icon flex-shrink-0">
              <i className="bi bi-book" />
            </div>
            <div className="feature-content">
              <h3>Continuous Learning</h3>
              <p>We embrace a culture of learning and curiosity, staying ahead with the latest trends and technologies. By investing in growth, we empower our team to deliver future-ready solutions.</p>
            </div>
          </div>
        </div>
        <div className="feature-item" data-aos="fade-left" data-aos-delay={400}>
          <div className="d-flex align-items-center gap-4">
            <div className="feature-icon flex-shrink-0">
              <i className="bi bi-globe" />
            </div>
            <div className="feature-content">
              <h3>Social Responsibility</h3>
              <p>We are committed to making a positive impact on society and the environment, promoting sustainability, diversity, and equality while contributing to community development.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    </section>

    {/* Card to Change */}
    <section id="call-to-action" className="call-to-action section">
  <div className="container" data-aos="fade-up" data-aos-delay={100}>
    <div className="row content justify-content-center align-items-center position-relative">
      {/* <div className="col-lg-8 mx-auto text-center">
        <h2 className="display-4 mb-4">
          Empowering Businesses with Innovation and Technology
        </h2>
        <p className="mb-4">
          At <strong>Bojo Tech</strong>, we believe that innovation isn’t just about technology — 
          it’s about transforming ideas into powerful digital experiences. 
          Partner with us to build scalable, secure, and future-ready solutions that drive growth and success.
        </p>
        <a href="#contact" className="btn btn-cta">
          Let’s Build the Future Together
        </a>
      </div> */}
      <div className="row content justify-content-center align-items-center position-relative">

      <div className="col-lg-8 mx-auto text-center">
  <h2 className="display-4 mb-4">
    Empowering Businesses with Innovation and Technology
  </h2>

  <p className="mb-4">
    At <strong>BojoTech</strong>, innovation isn't just technology —
    it's about transforming ideas into powerful digital experiences.
    Partner with us to build scalable, secure, future-ready solutions.
  </p>

  <Link to="/contact" className="btn btn-cta mt-4">
    Let’s Build the Future Together
  </Link>
</div>

{/* 👇 ref COUNTER wale section pe hi lagega */}
<div className="col-lg-4 mx-auto text-center" ref={bottomRef}>
  <div>
    <img
      src="assets/1.png"
      alt="Counters Background"
      className="img-fluid rounded-4"
    />
  </div>

  <div className="row mt-4">
    <div className="col-md-4">
      <h3 className="fw-bold" style={{ color: "#fff" }}>
        {bottomInView && <CountUp start={0} end={50} duration={4} />}+
      </h3>
      <p><strong>Projects Delivered</strong></p>
    </div>

    <div className="col-md-4">
      <h3 className="fw-bold" style={{ color: "#fff" }}>
        {bottomInView && <CountUp start={0} end={30} duration={4} />}+
      </h3>
      <p>
        <strong>
          Happy <br /> Clients
        </strong>
      </p>
    </div>

    <div className="col-md-4">
      <h3 className="fw-bold" style={{ color: "#fff" }}>
        {bottomInView && <CountUp start={0} end={80} duration={4} />}+
      </h3>
      <p><strong>Expert Engineers</strong></p>
    </div>
  </div>
</div>

      
      </div>
      
      
      

      {/* Abstract Background Elements */}
      <div className="shape shape-1">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path d="M47.1,-57.1C59.9,-45.6,68.5,-28.9,71.4,-10.9C74.2,7.1,71.3,26.3,61.5,41.1C51.7,55.9,35,66.2,16.9,69.2C-1.3,72.2,-21,67.8,-36.9,57.9C-52.8,48,-64.9,32.6,-69.1,15.1C-73.3,-2.4,-69.5,-22,-59.4,-37.1C-49.3,-52.2,-32.8,-62.9,-15.7,-64.9C1.5,-67,34.3,-68.5,47.1,-57.1Z" transform="translate(100 100)" />
        </svg>
      </div>
      <div className="shape shape-2">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path d="M41.3,-49.1C54.4,-39.3,66.6,-27.2,71.1,-12.1C75.6,3,72.4,20.9,63.3,34.4C54.2,47.9,39.2,56.9,23.2,62.3C7.1,67.7,-10,69.4,-24.8,64.1C-39.7,58.8,-52.3,46.5,-60.1,31.5C-67.9,16.4,-70.9,-1.4,-66.3,-16.6C-61.8,-31.8,-49.7,-44.3,-36.3,-54C-22.9,-63.7,-8.2,-70.6,3.6,-75.1C15.4,-79.6,28.2,-58.9,41.3,-49.1Z" transform="translate(100 100)" />
        </svg>
      </div>

      {/* Dot Pattern Groups */}
      <div className="dots dots-1">
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <pattern id="dot-pattern" x={0} y={0} width={20} height={20} patternUnits="userSpaceOnUse">
            <circle cx={2} cy={2} r={2} fill="currentColor" />
          </pattern>
          <rect width={100} height={100} fill="url(#dot-pattern)" />
        </svg>
      </div>
      <div className="dots dots-2">
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <pattern id="dot-pattern-2" x={0} y={0} width={20} height={20} patternUnits="userSpaceOnUse">
            <circle cx={2} cy={2} r={2} fill="currentColor" />
          </pattern>
          <rect width={100} height={100} fill="url(#dot-pattern-2)" />
        </svg>
      </div>

      <div className="shape shape-3">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path d="M43.3,-57.1C57.4,-46.5,71.1,-32.6,75.3,-16.2C79.5,0.2,74.2,19.1,65.1,35.3C56,51.5,43.1,65,27.4,71.7C11.7,78.4,-6.8,78.3,-23.9,72.4C-41,66.5,-56.7,54.8,-65.4,39.2C-74.1,23.6,-75.8,4,-71.7,-13.2C-67.6,-30.4,-57.7,-45.2,-44.3,-56.1C-30.9,-67,-15.5,-74,0.7,-74.9C16.8,-75.8,33.7,-70.7,43.3,-57.1Z" transform="translate(100 100)" />
        </svg>
      </div>
    </div>
  </div>
     </section>
{/* Card to Change */}


  {/* expertise Cards Section 
<section id="expertise-logos" className="features-logos section py-5">
  <div className="container text-center">
    <div
      className="section-title"
      data-aos="fade-up"
      style={{ marginBottom: "30px" }}
    >
      <h2>Trusted By The Best</h2>
      <p>
        Empowering some of the world's leading brands to drive innovation and business value
      </p>
    </div>

   <Swiper
  modules={[Autoplay]}
  spaceBetween={40}
  slidesPerView={5}
  autoplay={{ delay: 0, disableOnInteraction: false }}
  speed={1600}
  loop={true}
  breakpoints={{
    320: { slidesPerView: 2 },
    640: { slidesPerView: 3 },
    1024: { slidesPerView: 5 },
  }}
  className="tech-slider-logos"
>
  {techLogos.map((tech, index) => (
    <SwiperSlide key={index}>
      <img src={tech.logo} alt="logo" className="tech-logo" />
    </SwiperSlide>
  ))}
</Swiper>
  </div>
</section>
    
    <br></br>
     expertise Cards Section */}
      <section id="expertise-logos" className="features-logos section py-5">
       <div className="container text-center">
         <div
           className="section-title"
           data-aos="fade-up"
           style={{ marginBottom: "30px" }}
         >
           <h2>Trusted By The Best</h2>
           <p>
             Empowering some of the world's leading brands to drive innovation and business value
           </p>
         </div>
     
         <Swiper
           modules={[Autoplay]}
           spaceBetween={40}
           slidesPerView={5}
           // autoplay={{ delay: 0, disableOnInteraction: false }}
           autoplay={{
       delay: 1000,
       disableOnInteraction: false,
       pauseOnMouseEnter: true
     }}
     observer={true}
     observeParents={true}
           speed={1800}
           loop={true}
           breakpoints={{
             320: { slidesPerView: 2 },
             640: { slidesPerView: 3 },
             1024: { slidesPerView: 5 },
           }}
           className="tech-slider-logos"
         >
     
           <SwiperSlide>
             <img src={process.env.PUBLIC_URL + "/assets/logo/1.svg"} alt="logo1" className="tech-logo" />
           </SwiperSlide>
     
           <SwiperSlide>
             <img src={process.env.PUBLIC_URL + "/assets/logo/2.svg"} alt="logo2" className="tech-logo" />
           </SwiperSlide>
     
           <SwiperSlide>
             <img src={process.env.PUBLIC_URL + "/assets/logo/3.svg"} alt="logo3" className="tech-logo" />
           </SwiperSlide>
     
           <SwiperSlide>
             <img src={process.env.PUBLIC_URL + "/assets/logo/4.svg"} alt="logo4" className="tech-logo" />
           </SwiperSlide>
     
           <SwiperSlide>
             <img src={process.env.PUBLIC_URL + "/assets/logo/5.svg"} alt="logo5" className="tech-logo" />
           </SwiperSlide>
     
           <SwiperSlide>
             <img src={process.env.PUBLIC_URL + "/assets/logo/6.svg"} alt="logo6" className="tech-logo" />
           </SwiperSlide>
     
           <SwiperSlide>
             <img src={process.env.PUBLIC_URL + "/assets/logo/7.svg"} alt="logo7" className="tech-logo" />
           </SwiperSlide>
     
           <SwiperSlide>
             <img src={process.env.PUBLIC_URL + "/assets/logo/8.svg"} alt="logo8" className="tech-logo" />
           </SwiperSlide>
     
         </Swiper>
     
       </div>
     </section>

  
   <section id="blog" className="blog section">
  {/* Section Title */}
  <div className="container section-title" data-aos="fade-up">
    <h2>Innovation & Technology Insights</h2>
    <p>Stay ahead with the latest trends, tips, and innovations in software development, IT solutions, and digital transformation.</p>
  </div>

  <div className="container">
   
     <div className="row g-4">
          {blogsData.map((blog, index) => (
            <div
              key={blog.id}
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay={100 * (index + 1)}
            >
              <div className="blog-card shadow-sm rounded">
                <img
                  src={blog.image}
                  className="img-fluid rounded-top"
                  alt={blog.title}
                />
                <div className="blog-content p-4">
                  <h5>{blog.title}</h5>
                  <p>{blog.shortDesc}</p>
                  <Link to={`/blog/${blog.slug}`} className="btn btn-primary">
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
  </div>
   </section>

    {/* Testimonials Section */}

      <section id="testimonials" className="testimonials section light-background">
  {/* Section Title */}
  <div className="container section-title" data-aos="fade-up">
    <h2>What They Are Saying About Us</h2>
    <p>
      Our clients’ success stories reflect our commitment to excellence,
      innovation, and long-term partnerships built on trust.
    </p>
  </div>
  {/* End Section Title */}

  <div className="container">
    <div className="row g-5">

      {/* Testimonial 1 */}
      <div className="col-lg-6" data-aos="fade-up" data-aos-delay={100}>
        <div className="testimonial-item">
          {/* <img src="assets/img/testimonials/testimonials-1.jpg" className="testimonial-img" alt="John Molinari" /> */}
          <h3>John Molinari</h3>
          <h4>Product Manager - Tesla</h4>
          <div className="stars">
            <i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" />
          </div>
          <p>
            <i className="bi bi-quote quote-icon-left" />
            <span>
              BojoTech has been instrumental in transforming our digital
              infrastructure. Their expertise and commitment to excellence are unmatched.
              Thanks to their solutions, we've achieved a new level of efficiency and innovation.
            </span>
            <i className="bi bi-quote quote-icon-right" />
          </p>
        </div>
      </div>
      {/* End testimonial item */}

      {/* Testimonial 2 */}
      <div className="col-lg-6" data-aos="fade-up" data-aos-delay={200}>
        <div className="testimonial-item">
          {/* <img src="assets/img/testimonials/testimonials-2.jpg" className="testimonial-img" alt="Sriram Drona" /> */}
          <h3>Sriram Drona</h3>
          <h4>CTO - Cigna</h4>
          <div className="stars">
            <i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" />
          </div>
          <p>
            <i className="bi bi-quote quote-icon-left" />
            <span>
              Exceptional quality and attention to detail are hallmarks of Bojo’s work.
              They consistently exceeded our expectations and delivered top-tier performance.
            </span>
            <i className="bi bi-quote quote-icon-right" />
          </p>
        </div>
      </div>
      {/* End testimonial item */}

      {/* Testimonial 3 */}
      <div className="col-lg-6" data-aos="fade-up" data-aos-delay={300}>
        <div className="testimonial-item">
          {/* <img src="assets/img/testimonials/testimonials-3.jpg" className="testimonial-img" alt="Christopher Small" /> */}
          <h3>Christopher Small</h3>
          <h4>CTO - Vanguard</h4>
          <div className="stars">
            <i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" />
          </div>
          <p>
            <i className="bi bi-quote quote-icon-left" />
            <span>
              Working with Bojo has been an absolute pleasure. They understood our vision
              and delivered a custom software solution that surpassed expectations.
              Their professionalism and technical excellence are truly commendable.
            </span>
            <i className="bi bi-quote quote-icon-right" />
          </p>
        </div>
      </div>
      {/* End testimonial item */}

      {/* Extra Testimonial 4 */}
      <div className="col-lg-6" data-aos="fade-up" data-aos-delay={400}>
        <div className="testimonial-item">
          {/* <img src="assets/img/testimonials/testimonials-4.jpg" className="testimonial-img" alt="Priya Nair" /> */}
          <h3>Priya Nair</h3>
          <h4>Head of Product Strategy - Microsoft</h4>
          <div className="stars">
            <i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" /><i className="bi bi-star-fill" />
          </div>
          <p>
            <i className="bi bi-quote quote-icon-left" />
            <span>
              BojoTech is not just a vendor; they are a strategic partner.
              Their team brought fresh ideas, rapid execution, and measurable impact.
              I highly recommend them for any organization aiming for digital excellence.
            </span>
            <i className="bi bi-quote quote-icon-right" />
          </p>
        </div>
      </div>
      {/* End testimonial item */}

    </div>
  </div>
      </section>

   
    {/* Faq Section */}
   <section className="faq-9 faq section light-background" id="faq">
  <div className="container">
    <div className="row">
      <div className="col-lg-5" data-aos="fade-up">
        <h2 className="faq-title">Frequently Asked Questions</h2>
        <p className="faq-description">
          Get quick answers to some of the most common questions about our IT solutions, services, and how BojoTech can help your business grow.
        </p>
        <div className="faq-arrow d-none d-lg-block" data-aos="fade-up" data-aos-delay={200}>
          <svg
            className="faq-arrow"
            width={200}
            height={211}
            viewBox="0 0 200 211"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M198.804 194.488C189.279 189.596 179.529 185.52 169.407 182.07L169.384 182.049C169.227 181.994 169.07 181.939 168.912 181.884C166.669 181.139 165.906 184.546 167.669 185.615C174.053 189.473 182.761 191.837 189.146 195.695C156.603 195.912 119.781 196.591 91.266 179.049C62.5221 161.368 48.1094 130.695 56.934 98.891C84.5539 98.7247 112.556 84.0176 129.508 62.667C136.396 53.9724 146.193 35.1448 129.773 30.2717C114.292 25.6624 93.7109 41.8875 83.1971 51.3147C70.1109 63.039 59.63 78.433 54.2039 95.0087C52.1221 94.9842 50.0776 94.8683 48.0703 94.6608C30.1803 92.8027 11.2197 83.6338 5.44902 65.1074C-1.88449 41.5699 14.4994 19.0183 27.9202 1.56641C28.6411 0.625793 27.2862 -0.561638 26.5419 0.358501C13.4588 16.4098 -0.221091 34.5242 0.896608 56.5659C1.8218 74.6941 14.221 87.9401 30.4121 94.2058C37.7076 97.0203 45.3454 98.5003 53.0334 98.8449C47.8679 117.532 49.2961 137.487 60.7729 155.283C87.7615 197.081 139.616 201.147 184.786 201.155L174.332 206.827C172.119 208.033 174.345 211.287 176.537 210.105C182.06 207.125 187.582 204.122 193.084 201.144C193.346 201.147 195.161 199.887 195.423 199.868C197.08 198.548 193.084 201.144 195.528 199.81C196.688 199.192 197.846 198.552 199.006 197.935C200.397 197.167 200.007 195.087 198.804 194.488ZM60.8213 88.0427C67.6894 72.648 78.8538 59.1566 92.1207 49.0388C98.8475 43.9065 106.334 39.2953 114.188 36.1439C117.295 34.8947 120.798 33.6609 124.168 33.635C134.365 33.5511 136.354 42.9911 132.638 51.031C120.47 77.4222 86.8639 93.9837 58.0983 94.9666C58.8971 92.6666 59.783 90.3603 60.8213 88.0427Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>

      <div className="col-lg-7" data-aos="fade-up" data-aos-delay={300}>
        <div className="faq-container">

          {/* Q1 */}
          <div className="faq-item faq-active">
            <h3>What services does BojoTech provide?</h3>
            <div className="faq-content">
              <p>
                We offer a comprehensive range of IT services including custom software development, web and mobile app development, cloud computing, IT consulting, cybersecurity solutions, and data analytics.
              </p>
            </div>
            <i className="faq-toggle bi bi-chevron-right" />
          </div>

          {/* Q2 */}
          <div className="faq-item">
            <h3>How can your IT services benefit my business?</h3>
            <div className="faq-content">
              <p>
                Our solutions streamline operations, boost productivity, improve efficiency, and drive business growth. We use technology to deliver data-driven insights, enhance security, and create exceptional digital experiences for your customers.
              </p>
            </div>
            <i className="faq-toggle bi bi-chevron-right" />
          </div>

          {/* Q3 */}
          <div className="faq-item">
            <h3>Can you handle projects of any size?</h3>
            <div className="faq-content">
              <p>
                Absolutely! From startups to large enterprises, we have experience delivering tailored solutions for projects of any scale and complexity.
              </p>
            </div>
            <i className="faq-toggle bi bi-chevron-right" />
          </div>

          {/* Q4 */}
          <div className="faq-item">
            <h3>How long does it take to develop custom software?</h3>
            <div className="faq-content">
              <p>
                Timelines depend on project complexity, scope, and features. We collaborate closely with clients to define clear milestones and ensure on-time delivery without compromising quality.
              </p>
            </div>
            <i className="faq-toggle bi bi-chevron-right" />
          </div>

          {/* Q5 */}
          <div className="faq-item">
            <h3>What industries do you serve?</h3>
            <div className="faq-content">
              <p>
                We serve clients across diverse industries such as healthcare, finance, e-commerce, education, and manufacturing — offering tailored IT solutions to meet each sector’s unique needs.
              </p>
            </div>
            <i className="faq-toggle bi bi-chevron-right" />
          </div>

          {/* Q6 */}
          <div className="faq-item">
            <h3>How do you ensure the security of my data?</h3>
            <div className="faq-content">
              <p>
                We implement strict security measures, including encryption, access control, and vulnerability testing, to safeguard your data. Our cybersecurity protocols follow the latest industry standards.
              </p>
            </div>
            <i className="faq-toggle bi bi-chevron-right" />
          </div>

          {/* Q7 */}
          <div className="faq-item">
            <h3>Do you offer post-development support and maintenance?</h3>
            <div className="faq-content">
              <p>
                Yes, we provide ongoing maintenance and technical support after project delivery to ensure continuous performance, updates, and quick issue resolution.
              </p>
            </div>
            <i className="faq-toggle bi bi-chevron-right" />
          </div>

          {/* Q8 */}
          <div className="faq-item">
            <h3>How do you maintain the quality of your services?</h3>
            <div className="faq-content">
              <p>
                We follow industry best practices, perform rigorous testing, and conduct multiple quality assurance checks to deliver reliable, efficient, and high-performing digital solutions.
              </p>
            </div>
            <i className="faq-toggle bi bi-chevron-right" />
          </div>

        </div>
      </div>
    </div>
  </div>
   </section>

    {/* /Faq Section */}

    {/* Contact Section */}
    <section id="contact" className="contact section light-background">
    {/* Section Title */}
  <div className="container section-title" data-aos="fade-up">
    <h2>Contact BojoTech</h2>
    <p>We relentlessly pursue opportunities for others because when we all work together, anything is possible.</p>
  </div>
  
  <div className="container" data-aos="fade-up" data-aos-delay={100}>
    <div className="row g-4 g-lg-5">

      {/* Contact Info */}
       <div className="col-lg-5">
        <div className="info-box" data-aos="fade-up" data-aos-delay={200}>
          <h3>Contact Info</h3>
          <p>We empower job seekers and businesses with customized staffing solutions for success.</p>

          
            <div className="info-item" data-aos="fade-up" data-aos-delay={300}>
            <div className="icon-box">
              <i className="bi bi-geo-alt" />
            </div>
            <div className="content">
              <h4>India Office Address</h4>
              <p>BojoTech</p>
              <p>F-2, nirmal complex, Plot no. 9-C, Govind garden, near punjab national bank, Raisen road, Govindpura, Bhopal- 462023</p>
            </div>
          </div>

          {/* <div className="info-item" data-aos="fade-up" data-aos-delay={300}>
            <div className="icon-box">
              <i className="bi bi-geo-alt" />
            </div>
            <div className="content">
              <h4>USA Office Address</h4>
              <p>CodeYuki LLC</p>
              <p>2486 Masons Ferry Dr # 103, Herndon, Virginia</p>
              <p>20171, USA</p>
            </div>
          </div> */}

          <div className="info-item" data-aos="fade-up" data-aos-delay={400}>
            <div className="icon-box">
              <i className="bi bi-envelope" />
            </div>
            <div className="content">
              <h4>Email</h4>
              <p>info@bojotech.com</p>
            </div>
            
            
          </div>
           <div className="info-item" data-aos="fade-up" data-aos-delay={400}>
            <div className="icon-box">
              <i className="bi bi-phone" />
            </div>
           
            <div className="content">
              <h4>Contact</h4>
              <p>+91 9009696937</p>
              {/* <p>+1 (267) 841-8017</p> */}
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form */}

    <div className="col-lg-7">
      <div className="contact-form" data-aos="fade-up" data-aos-delay={300}>
        <h3>Get In Touch</h3>
        <p>We are ready to assist you. Send us a message and our team will get back to you promptly.</p>
        <form onSubmit={handleSubmit} className="php-email-form" data-aos="fade-up" data-aos-delay={200}>
          <div className="row gy-4">
            <div className="col-md-6">
              <input type="text" name="name" className="form-control" placeholder="Your Name" required />
            </div>
            <div className="col-md-6">
              <input type="email" name="email" className="form-control" placeholder="Your Email" required />
            </div>
            <div className="col-12">
              <input type="text" name="subject" className="form-control" placeholder="Subject" required />
            </div>
            <div className="col-12">
              <textarea name="message" className="form-control" rows={6} placeholder="Message" required />
            </div>
            <div className="col-12 text-center">
              {loading && <div className="loading">Sending...</div>}

              {statusMsg && (
                <div
                  style={{
                    padding: "10px 15px",
                    marginBottom: "10px",
                    borderRadius: "25px",
                    color: "#fff",
                    backgroundColor: isSuccess ? "green" : "red",
                  }}
                >
                  {statusMsg}
                </div>
              )}

              <button type="submit" className="btn btn-primary" disabled={loading}>
                Send Message
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    </div>
  </div>
</section>
    {/* /Contact Section */}
  
</div>

  )
}

export default Home;

